import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import * as api from 'api/business/business';
import * as toastActions from 'state/toast/actions';
import {
  GET_ALL_BUSINESS,
  CHANGE_BUSINESS_FILTER,
  GET_EMPLOYEE_SLOTS,
  GET_EMPLOYEE_SLOTS_LOGS,
  GET_BUSINESS_DETAILS,
  CREATE_EMPLOYEE_SLOT,
  UPDATE_EMPLOYEE_SLOT_IS_RENEWABLE_STATUS,
  UPDATE_BUSINESS_PACKAGE,
  GET_GOBIZ_LINKING,
  GET_OUTLETS,
  ADD_OUTLET_SLOT,
  GET_DEVICE_LOGS,
  GET_BILLING_HISTORY,
  UPDATE_OUTLET_SUBSCRIPTIONS,
  GET_FEATURE_SUBSCRIPTIONS,
  ACTIVATE_FEATURE_SUBSCRIPTIONS_OUTLET,
  GET_OUTLET_SLOTS,
  UPDATE_OUTLETS_SLOTS,
  GET_OUTLET_LOGS,
  UPDATE_OWNER_PHONE,
  VOID_INVOICE,
  OPEN_INVOICE_FILE,
  GET_INVOICE_VOID_LOGS,
  UPDATE_BUSINESS_ENTITY_TYPE,
} from 'state/actionTypes';
import {
  creatingEmployeeSlot,
  getAllBusinessSuccess,
  getBusinessDetailsSuccess,
  getEmployeeSlotsLogsSuccess,
  getEmployeeSlotsSuccess,
  getGoBizLinkingSuccess,
  getPurchasedEmployeeSlotsSuccess,
  gettingAllBusiness,
  gettingBusinessDetails,
  gettingEmployeeSlots,
  gettingEmployeeSlotsLogs,
  gettingGoBizLinking,
  updatingBusinessPackage,
  updatingEmployeeSlotIsRenewableStatus,
  getDeviceLogsSuccessAction,
  loadingOutletsAction,
  getBillingHistorySuccessAction,
  getFeatureSubscriptionsSuccessAction,
  getOutletSlotsSuccessAction,
  getOutletsSuccessAction,
  updateOutletSubscriptionUIAction,
  loadingOutletLogsAction,
  getOutletLogsSuccessAction,
  updatingOwnerPhone,
  closeUpdateOwnerPhoneModal,
  setOwnerPhoneError,
  voidingInvoiceAction,
  getInvoiceVoidLogsSuccessAction,
  loadingInvoiceVoidLogsAction,
  updatingBusinessEntityType,
  closeUpdateBusinessEntityModal,
  setBusinessEntityTypeError,
} from './actions';

export function* getAllBusiness({ payload }) {
  try {
    yield put(gettingAllBusiness(true));
    const {
      data: { data, paging },
    } = yield call(api.performGetAllBusiness, payload);
    yield put(getAllBusinessSuccess({ data, paging }));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get business data', error.message)
    );
  } finally {
    yield put(gettingAllBusiness(false));
  }
}

export function* getEmployeeSlots({ payload }) {
  try {
    yield put(gettingEmployeeSlots(true));
    const { data } = yield call(api.performGetEmployeeSlots, payload);
    yield put(getEmployeeSlotsSuccess(data));
    const purchasedEmployeeSLotsData = data.data.slots.filter(
      x => x.status === 'Purchased'
    );
    yield put(getPurchasedEmployeeSlotsSuccess(purchasedEmployeeSLotsData));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get employee slots', error.message)
    );
  } finally {
    yield put(gettingEmployeeSlots(false));
  }
}

export function* getEmployeeSlotsLogs({ payload }) {
  try {
    yield put(gettingEmployeeSlotsLogs(true));
    const { data } = yield call(api.performGetEmployeeSlotsLogs, payload);
    yield put(getEmployeeSlotsLogsSuccess(data));
  } catch (error) {
    yield put(
      toastActions.errorMessage(
        'Failed to get employee slots logs',
        error.message
      )
    );
  } finally {
    yield put(gettingEmployeeSlotsLogs(false));
  }
}

export function* getBusinessDetails({ payload }) {
  try {
    yield put(gettingBusinessDetails(true));
    const { data } = yield call(api.performGetBusinessDetails, payload);
    yield put(getBusinessDetailsSuccess(data));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get business profile', error.message)
    );
  } finally {
    yield put(gettingBusinessDetails(false));
  }
}

export function* createEmployeeSlot({ payload }) {
  try {
    yield put(creatingEmployeeSlot(true));
    yield call(api.performCreateEmployeeSlot, payload);
    yield call(getEmployeeSlots, { payload });
    yield call(getEmployeeSlotsLogs, { payload });
    yield put(toastActions.successMessage('Employee slot successfully added'));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to add employee slot', error.message)
    );
  } finally {
    yield put(creatingEmployeeSlot(false));
  }
}

export function* updateEmployeeSlotIsRenewableStatus({ payload }) {
  try {
    yield put(updatingEmployeeSlotIsRenewableStatus(true));
    yield call(api.performUpdateEmployeeSlotIsRenewableStatus, payload);
    yield call(getEmployeeSlots, { payload });
    yield call(getEmployeeSlotsLogs, { payload });
    yield put(
      toastActions.successMessage('Employee slot successfully updated')
    );
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to update employee slot', error.message)
    );
  } finally {
    yield put(updatingEmployeeSlotIsRenewableStatus(false));
  }
}

export function* updateBusinessPackage({ payload }) {
  try {
    yield put(updatingBusinessPackage(true));
    yield call(api.performPatchBusinessPackage, payload);
    yield call(getBusinessDetails, { payload });
    yield put(
      toastActions.successMessage('Business package successfully updated')
    );
  } catch (error) {
    yield put(
      toastActions.errorMessage(
        'Failed to update business package',
        error.message
      )
    );
  } finally {
    yield put(updatingBusinessPackage(false));
  }
}

export function* updateOwnerPhone({ payload }) {
  try {
    yield put(updatingOwnerPhone(true));
    yield put(setOwnerPhoneError(null));
    yield call(api.performUpdateOwnerPhone, payload);

    try {
      const { data } = yield call(api.performGetBusinessDetails, payload);
      yield put(getBusinessDetailsSuccess(data));
    } catch (refetchError) {
      yield put(
        toastActions.errorMessage(
          'Failed to get business profile',
          refetchError.message
        )
      );
    }

    yield put(
      toastActions.successMessage('Owner phone number successfully updated')
    );
    yield put(closeUpdateOwnerPhoneModal());
  } catch (error) {
    yield put(setOwnerPhoneError(error.message));
  } finally {
    yield put(updatingOwnerPhone(false));
  }
}

export function* updateBusinessEntityType({ payload }) {
  try {
    yield put(updatingBusinessEntityType(true));
    yield put(setBusinessEntityTypeError(null));
    yield call(api.performUpdateBusinessEntityType, payload);

    try {
      const { data } = yield call(api.performGetBusinessDetails, payload);
      yield put(getBusinessDetailsSuccess(data));
    } catch (refetchError) {
      yield put(
        toastActions.errorMessage(
          'Failed to get business profile',
          refetchError.message
        )
      );
    }

    yield put(
      toastActions.successMessage('Business entity successfully updated')
    );
    yield put(closeUpdateBusinessEntityModal());
  } catch (error) {
    yield put(setBusinessEntityTypeError(error.message));
  } finally {
    yield put(updatingBusinessEntityType(false));
  }
}

export function* getGoBizLinking({ payload }) {
  try {
    yield put(gettingGoBizLinking(true));
    const {
      data: { data, paging },
    } = yield call(api.performGetOutlets, payload);
    yield put(getGoBizLinkingSuccess({ data, paging }));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get GoBiz linking', error.message)
    );
  } finally {
    yield put(gettingGoBizLinking(false));
  }
}

export function* getOutlets({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    const {
      data: { data, paging },
    } = yield call(api.performGetOutlets, payload);
    yield put(getOutletsSuccessAction({ data, paging }));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get outlets', error.message)
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* addOutletSlot({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    yield call(api.performAddOutletSlot, payload);
    yield put(
      toastActions.successMessage('Outlet slot has been successfully added')
    );
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to add outlet slot', error.message)
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* getDeviceLogs({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    const {
      data: { data },
    } = yield call(api.performGetDeviceLogs, payload);
    yield put(getDeviceLogsSuccessAction({ data }));
  } catch (error) {
    yield put(getDeviceLogsSuccessAction({}));
    yield put(
      toastActions.errorMessage('Failed to get device logs', error.message)
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* getBillingHistory({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    const {
      data: { data },
    } = yield call(api.performGetBillingHistory, payload);
    yield put(getBillingHistorySuccessAction({ data }));
  } catch (error) {
    yield put(getBillingHistorySuccessAction({}));
    yield put(
      toastActions.errorMessage('Failed to get billing history', error.message)
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* voidInvoice({ payload }) {
  try {
    const { businessId } = payload;

    yield put(voidingInvoiceAction(true));
    yield call(api.performVoidInvoice, payload);
    yield call(getBillingHistory, { payload: { businessId } });
    yield put(toastActions.successMessage('Invoice successfully voided'));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to void invoice', error.message)
    );
  } finally {
    yield put(voidingInvoiceAction(false));
  }
}

export function* openInvoiceFile({ payload }) {
  try {
    const {
      data: { data: fileUrl },
    } = yield call(api.performGetInvoiceFileUrl, payload);
    window.open(fileUrl, '_blank', 'noopener,noreferrer');
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get invoice link', error.message)
    );
  }
}

export function* getInvoiceVoidLogs({ payload }) {
  try {
    yield put(loadingInvoiceVoidLogsAction(true));
    const {
      data: {
        data: { invoice_void_logs: data },
        paging,
      },
    } = yield call(api.performGetInvoiceVoidLogs, payload);
    yield put(getInvoiceVoidLogsSuccessAction({ data, paging }));
  } catch (error) {
    yield put(getInvoiceVoidLogsSuccessAction({}));
    yield put(
      toastActions.errorMessage(
        'Failed to get invoice void logs',
        error.message
      )
    );
  } finally {
    yield put(loadingInvoiceVoidLogsAction(false));
  }
}

export function* updateOutletSubscriptions({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    yield call(api.performUpdateOutletSubscriptions, payload);
    yield put(updateOutletSubscriptionUIAction(payload));
    yield put(
      toastActions.successMessage('Successfully to update outlet subscriptions')
    );
  } catch (error) {
    yield put(
      toastActions.errorMessage(
        'Failed to update outlet subscriptions',
        error.message
      )
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* getFeatureSubscriptions({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    const {
      data: { data, paging },
    } = yield call(api.performGetFeatureSubscriptions, payload);
    yield put(getFeatureSubscriptionsSuccessAction({ data, paging }));
  } catch (error) {
    yield put(
      toastActions.errorMessage(
        'Failed to get feature subscriptions',
        error.message
      )
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* activateFeatureSubscriptionsOutlet({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    yield call(api.performActivateFeatureSubscriptionsOutlet, payload);
    const featureSubscriptionsPayload = {
      businessId: payload.businessId,
      page: 1,
      size: 10,
    };
    yield call(getFeatureSubscriptions, {
      payload: featureSubscriptionsPayload,
    });
    yield put(
      toastActions.successMessage('Successfully to activate the feature')
    );
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to activate the feature', error.message)
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* getOutletSlots({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    const {
      data: { data },
    } = yield call(api.performGetOutletSlots, payload);
    yield put(getOutletSlotsSuccessAction({ data }));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get outlets slots', error.message)
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* updateOutletsSlots({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    yield call(api.performUpdateOutletSlots, payload);
    const reloadPayload = {
      businessId: payload.business_id,
    };
    yield call(getOutletSlots, {
      payload: reloadPayload,
    });
    yield put(
      toastActions.successMessage('Successfully to update outlet slots')
    );
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to update outlet slots', error.message)
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* getOutletLogs({ payload }) {
  try {
    yield put(loadingOutletLogsAction(true));
    const {
      data: { data, paging },
    } = yield call(api.performGetOutletLogs, payload);
    yield put(getOutletLogsSuccessAction({ data, paging }));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get outlet logs', error.message)
    );
  } finally {
    yield put(loadingOutletLogsAction(false));
  }
}

export default function* saga() {
  yield takeEvery(GET_ALL_BUSINESS, getAllBusiness);
  yield takeEvery(CHANGE_BUSINESS_FILTER, getAllBusiness);
  yield takeEvery(GET_EMPLOYEE_SLOTS, getEmployeeSlots);
  yield takeEvery(GET_EMPLOYEE_SLOTS_LOGS, getEmployeeSlotsLogs);
  yield takeEvery(GET_BUSINESS_DETAILS, getBusinessDetails);
  yield takeEvery(CREATE_EMPLOYEE_SLOT, createEmployeeSlot);
  yield takeEvery(
    UPDATE_EMPLOYEE_SLOT_IS_RENEWABLE_STATUS,
    updateEmployeeSlotIsRenewableStatus
  );
  yield takeEvery(UPDATE_BUSINESS_PACKAGE, updateBusinessPackage);
  yield takeEvery(UPDATE_OWNER_PHONE, updateOwnerPhone);
  yield takeEvery(UPDATE_BUSINESS_ENTITY_TYPE, updateBusinessEntityType);
  yield takeEvery(GET_GOBIZ_LINKING, getGoBizLinking);
  yield takeLatest(GET_OUTLETS, getOutlets);
  yield takeLatest(ADD_OUTLET_SLOT, addOutletSlot);
  yield takeLatest(GET_DEVICE_LOGS, getDeviceLogs);
  yield takeLatest(GET_BILLING_HISTORY, getBillingHistory);
  yield takeLatest(VOID_INVOICE, voidInvoice);
  yield takeLatest(OPEN_INVOICE_FILE, openInvoiceFile);
  yield takeLatest(GET_INVOICE_VOID_LOGS, getInvoiceVoidLogs);
  yield takeLatest(UPDATE_OUTLET_SUBSCRIPTIONS, updateOutletSubscriptions);
  yield takeLatest(GET_FEATURE_SUBSCRIPTIONS, getFeatureSubscriptions);
  yield takeLatest(
    ACTIVATE_FEATURE_SUBSCRIPTIONS_OUTLET,
    activateFeatureSubscriptionsOutlet
  );
  yield takeLatest(GET_OUTLET_SLOTS, getOutletSlots);
  yield takeLatest(UPDATE_OUTLETS_SLOTS, updateOutletsSlots);
  yield takeLatest(GET_OUTLET_LOGS, getOutletLogs);
}
